/**
 * Records clicks on the header's "Find your kit" button.
 *
 * This is the click that sends someone to the quiz, which is a different moment from
 * quote_quiz_started: that one fires on the quiz page when they actually begin. Keeping the two
 * apart is what shows how many people the button sends and how many of them start.
 *
 * Only commercial, non-identifying fields are pushed, like the quiz's own analytics module.
 */

const EVENT = "quote_quiz_entry_clicked";

/** @param {string} url @returns {string} The page without its query string or fragment */
function pagePath(url) {
  try {
    const parsed = new URL(url, location.origin);
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    return "";
  }
}

document.addEventListener("click", (event) => {
  const target = event.target instanceof Element ? event.target.closest(".header-quiz-button") : null;
  if (!target) return;

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: EVENT,
      source: "header",
      page_url: pagePath(location.href),
      link_url: pagePath(target.getAttribute("href") || ""),
    });
  } catch {
    // Analytics must never stand between the visitor and the quiz.
  }
});
